module.exports = __webpack_public_path__ + "static/bed-nav-square-3918c240e9f27472c4a1e89682c380a3.jpeg";